/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';
import { TherapistProfileSerializerMinimal } from './therapistProfileSerializerMinimal';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarAvailability { 
    id: number;
    therapist: TherapistProfileSerializerMinimal;
    start: string;
    end: string;
    availabilityMode: AvailabilityModeEnum;
    externalSystem: ExternalSystemEnum | null;
}
export namespace CalendarAvailability {
}

export const CalendarAvailability_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAvailability_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAvailability_start_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAvailability_end_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAvailability_availabilityMode_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAvailability_externalSystem_Validators: ValidatorFn[] =
    [  Validators.required, ];


